import { render, staticRenderFns } from "./RecursiveDirectoryTree.vue?vue&type=template&id=05238fe3&scoped=true&"
import script from "./RecursiveDirectoryTree.vue?vue&type=script&lang=js&"
export * from "./RecursiveDirectoryTree.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveDirectoryTree.vue?vue&type=style&index=0&id=05238fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05238fe3",
  null
  
)

export default component.exports